import {JsonAdapter} from "../helpers/JsonAdapter";

export class Grade {
  id: string = "";
  name: string = "";

  static create(object:any): Grade {
    const item = JsonAdapter.fill(new Grade(), object);

    return item;
  }

  static createMultiple(objects: Grade[]): Grade[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(Grade.create(objects[i]));
    }
    return items;
  }
}
